export default "__VITE_ASSET__DiPwcr42__"